export const indicators = {
  gdhi: "مراقبة الصحة الرقمية العالمية",
  indicatorGuide: "دليل المؤشر",
  paragraph1:
    "مراقب الصحة الرقمية العالمية هو مورد رقمي تفاعلي يقوم بتتبع ورصد وتقييم مدى استخدام التكنولوجيا الرقمية للصحة عبر البلدان. ويستخدم سبع فئات رئيسية من المؤشرات لتتبع التقدم المحرز.",
  indicator: "تفاصيل",
  selected_indicator: "المؤشر المحدد",
};
